import React from "react";
import { BrowserRouter, Redirect, Switch } from "react-router-dom";
import Auth from "use-eazy-auth"
import { AuthRoute, GuestRoute } from "use-eazy-auth/routes";
import { Login } from "./Login";
import Planner from "./Planner";
import "./style.css";

async function loginCall({ username, password }) {
  const res = await fetch("/api/login", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ username, password })
  })
  const data = await res.json()
  if (res.status < 400) {
    return { accessToken: data.token }
  } else {
    throw new Error("Failed to login")
  }
}

async function meCall(token) {
  const res = await fetch("/api/me", {
    method: "POST",
    headers: {
      "Content-Type": "application/json"
    },
    body: JSON.stringify({ token })
  })
  const data = await res.json()
  if (res.status < 400) {
    return data
  } else {
    throw new Error("Failed to me")
  }
}

function App() {
  return (
    <Auth loginCall={loginCall} meCall={meCall} >
      <BrowserRouter>
        <Switch>
          <AuthRoute path="/" exact>
            <Planner />
          </AuthRoute>
          <GuestRoute path="/login" component={Login} />
          <Redirect to="/" />
        </Switch>
      </BrowserRouter>
    </Auth>
  );
}

export default App;
